export default __webpack_public_path__ + "static/media/job_offer20_s.815aa7b8.jpg";